<section
    data-testid="block-text"
    hBindSPANavigationForCTA
    [innerHtml]="blockText.text | resolveTokens : blockText.tokens | trustHtml"
    [hAnimateOnScroll]="{
        animate: blockText.hasAnimation,
        threshold: 0.2
    }"
    [class.white-background]="blockText.whiteBackground"
    class="block-text">
</section>
